import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AdminMontessoriTemplateCard from "./AdminMontessoriTemplateCard";
import AdminMontessoriGenerateCard from "./AdminMontessoriGenerateCard";
import AdminMontessoriHistoryCard from "./AdminMontessoriHistoryCard";

const AdminSwitchMontessoriCard = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get("tab") || "template";

  const step = tabParam === "history" ? 3 : tabParam === "generate" ? 2 : 1;

  const handleStepChange = (newStep) => {
    const tabName =
      newStep === 3 ? "history" : newStep === 2 ? "generate" : "template";
    queryParams.set("tab", tabName);
    navigate({ search: queryParams.toString() });
  };

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <AdminMontessoriTemplateCard />
          </div>
        );
      case 2:
        return (
          <div>
            <AdminMontessoriGenerateCard />
          </div>
        );
      case 3:
        return (
          <div>
            <AdminMontessoriHistoryCard />
          </div>
        );
      default:
        return (
          <div>
            <AdminMontessoriTemplateCard />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg">
          <div
            onClick={() => handleStepChange(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Template</div>
          </div>
          <div
            onClick={() => handleStepChange(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Generate</div>
          </div>
          <div
            onClick={() => handleStepChange(3)}
            className={`iskool-tab-item ${
              step === 3 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">History</div>
          </div>
        </div>
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default AdminSwitchMontessoriCard;
